module.exports = __webpack_public_path__ + "static/media/credit-card_master.957c8183.svg";